<template>
    <div class="wrapper">
        <router-view/>
    </div>
</template>
<script>
  import { mapState, mapMutations } from "vuex";
  import help from "./assets/js/help";
  import { format } from "timeago.js";
  export default {
    name: "App",
    data () {
      return {
        info: {}
      };
    },
    computed: {
      ...mapState(["uid", "token", "time", "isTest"]),
      isDevelopment () {
        return process.env.NODE_ENV === "development";
      },
    },
    methods: {
      ...mapMutations(["setUid", "setTotalIngral", "setAppInfo"]),
    },
    mounted () {
      if (!this.uid) {
        const uidStorage = help.getStorage("uid");
        if (uidStorage) {
          this.setUid(uidStorage);
        } else {
          this.setUid("h5" + help.randomString(13));
        }
      }
      // const _data = format(1544666010224, 'zh_CN');
      // console.log(_data);
    }
  };
</script>
<style lang="less">
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        & > .wrapper {
            max-width: 412px;
            margin: 0 auto;
            min-height: 100vh;
        }
        & .loading {
            padding: 15px 0;
            text-align: center;
        }
    }
    main {
        min-height: 100vh;
    }
    body {
        background: #fff;
    }
    #nav {
        display: block;
        padding: 30px;
        a {
            font-weight: bold;
            color: #2c3e50;
            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
    .van-image {
        vertical-align: middle;
    }
    .custom-image .van-empty__image {
        width: 375px;
        height: 160px;
    }
</style>
